
import { defineComponent, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n/index';
import KTMenu from '@/layout/aside/Menu.vue';
import { asideTheme } from '@/core/helpers/config';
import { ASIDE_MINIMIZE_STATE_KEY } from '@/core/constants/const';

export default defineComponent({
  name: 'KTAside',
  components: {
    KTMenu,
  },
  props: {
    lightLogo: String,
    darkLogo: String,
  },
  setup() {
    const { t } = useI18n();
    const isAsideMinimized = ref(false);
    const isAsideHoverSuppressed = ref(false);
    const minimizeAttribute = 'data-kt-aside-minimize';

    const setAsideMinimizeState = (
      shouldMinimize: boolean,
      suppressHover = false
    ) => {
      if (shouldMinimize) {
        document.body.setAttribute(minimizeAttribute, 'on');
        window.localStorage.setItem(ASIDE_MINIMIZE_STATE_KEY, 'on');
      } else {
        document.body.removeAttribute(minimizeAttribute);
        window.localStorage.setItem(ASIDE_MINIMIZE_STATE_KEY, 'off');
      }

      isAsideMinimized.value = shouldMinimize;
      isAsideHoverSuppressed.value = suppressHover;
    };

    const toggleAsideMinimize = () => {
      const isMinimized =
        document.body.getAttribute(minimizeAttribute) === 'on';

      setAsideMinimizeState(!isMinimized, !isMinimized);
    };

    const handleAsideMouseLeave = () => {
      if (isAsideMinimized.value) {
        isAsideHoverSuppressed.value = false;
      }
    };

    onMounted(() => {
      const storedAsideMinimizeState = window.localStorage.getItem(
        ASIDE_MINIMIZE_STATE_KEY
      );
      const shouldMinimize = storedAsideMinimizeState
        ? storedAsideMinimizeState === 'on'
        : false;

      setAsideMinimizeState(shouldMinimize);
    });

    return {
      asideTheme,
      isAsideHoverSuppressed,
      isAsideMinimized,
      handleAsideMouseLeave,
      toggleAsideMinimize,
      t,
    };
  },
});
